import { prepend } from "../../string";
export const reduceUrlParts = (parts, queryString) => {
    const url = parts.reduce((url, part, i) => {
        if (part) {
            return (url + (i === 0 ? part : prepend({ string: part, prefix: "/" })));
        }
        return url;
    }, "");
    const query = queryString
        ? prepend({ string: queryString, prefix: "?" })
        : "";
    return url + query;
};
